
import React from "react";

//** Lib */

import DataAnalyzerList from "./DataAnalyzerList";
import CustomTab from "../../components/common/RenderTab/CustomTab";
import { hasFunctionalPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation";
import { securityKey } from "../../navigation/SecurityKey";



function DataAnalyzer() {

  const hasOpenTabPermission = hasFunctionalPermission(securityKey.DATAANALYZEROPENTAB);
  const hasArchiveTabPermission = hasFunctionalPermission(securityKey.DATAANALYZERARCHIVETAB);


  const data = [
    {
      id: "1",
      tabTitle: "Open",
      tabContent: <DataAnalyzerList openStatus={1} />,
      isVisible: hasOpenTabPermission?.hasAccess,
    },
    {
      id: "2",
      tabTitle: "Archive",
      tabContent: <DataAnalyzerList openStatus={2} />,
      isVisible: hasArchiveTabPermission?.hasAccess,
    },
  ];
    

  return (
    <>
     

      <CustomTab data={data} />
    </>
  );
}

export default DataAnalyzer;
